(function () {
  var roots = document.querySelectorAll('.bench-fx');
  if (!roots.length) return;

  var SYN = {
    'gba': 'game boy advance', 'gbc': 'game boy color', 'gb': 'game boy', 'dmg': 'game boy original',
    'sp': 'game boy advance sp', 'joycon': 'joy-con', 'joy': 'joy-con', 'joycons': 'joy-con',
    'ds4': 'dualshock 4', 'dualshock': 'dualshock 4', 'dualsense': 'dualsense',
    'joystick': 'stick', 'thumbstick': 'stick', 'analog': 'stick', 'drifting': 'drift', 'drifts': 'drift',
    'charging': 'charge', 'charger': 'charge', 'wont': "won't", 'doesnt': "doesn't", 'dont': "don't",
    'turn': 'power', 'boot': 'power', 'dead': 'power', 'black': 'no picture', 'blank': 'no picture',
    'display': 'screen', 'lcd': 'screen', 'audio': 'sound', 'speaker': 'sound', 'volume': 'sound',
    'cartridge': 'cart', 'game': 'cart', 'loading': 'read', 'reading': 'read', 'reads': 'read',
    'skipping': 'skip', 'scratched': 'scratches', 'scratch': 'scratches',
    'sticky': 'stick', 'stuck': 'sticks', 'unresponsive': 'dead', 'broke': 'broken', 'cracked': 'crack',
    'liquid': 'spilled', 'water': 'spilled', 'wet': 'spilled', 'spill': 'spilled',
    'coke': 'spilled', 'soda': 'spilled', 'drink': 'spilled', 'beer': 'spilled', 'juice': 'spilled', 'coffee': 'spilled',
    'stripped': 'stripped', 'rounded': 'stripped', 'screw': 'screw', 'screws': 'screw',
    'yellow': 'yellowed', 'yellowing': 'yellowed', 'hdmi': 'hdmi', 'tv': 'tv', 'signal': 'signal',
    'n64': 'n64', 'nes': 'nes', 'snes': 'snes', 'ps1': 'ps1', 'psx': 'ps1', 'ps2': 'ps2', 'ps3': 'ps3',
    'ps4': 'ps4', 'ps5': 'ps5', 'xbox': 'xbox', '360': 'xbox 360', 'switch': 'switch', 'lite': 'switch lite',
    'genesis': 'genesis', 'megadrive': 'genesis', 'mega': 'genesis', 'gamecube': 'gamecube', 'gc': 'gamecube',
    'dreamcast': 'dreamcast', 'psp': 'psp', 'vita': 'vita', '3ds': '3ds', 'dsi': 'dsi', 'ds': 'ds',
    'gamegear': 'game gear', 'wii': 'wii', 'controller': 'controller', 'pad': 'controller', 'gamepad': 'controller'
  };

  function norm(s) {
    return String(s || '').toLowerCase().replace(/[’']/g, "'").replace(/[^a-z0-9' \-]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  var SYSTEMS = ['switch', 'n64', 'nes', 'snes', 'ps1', 'ps2', 'ps3', 'ps4', 'ps5', 'xbox', '360', 'psp', 'vita', '3ds', '2ds', 'ds', 'dsi', 'gamecube', 'dreamcast', 'genesis', 'saturn', 'wii', 'gba', 'gbc', 'dmg', 'boy', 'gear', 'joy-con', 'controller'];

  // Situation words decide the answer on their own, whatever system is named:
  // a spill is a spill on any console.
  var HARD = ['spilled', 'stripped', 'yellowed', 'corrosion'];

  function bigrams(q) {
    var w = norm(q).split(' ').filter(Boolean), out = [];
    for (var i = 0; i < w.length - 1; i++) out.push(w[i] + ' ' + w[i + 1]);
    return out;
  }

  function expand(q) {
    var words = norm(q).split(' ').filter(Boolean);
    var noCart = /game (boy|gear)|gamecube/.test(words.join(' '));
    var out = [];
    words.forEach(function (w) {
      out.push(w);
      if (w === 'game' && noCart) return;
      if (SYN[w]) SYN[w].split(' ').forEach(function (x) { if (out.indexOf(x) < 0) out.push(x); });
    });
    return out.filter(function (w) { return w.length > 1 && ['the', 'my', 'is', 'it', 'on', 'in', 'a', 'an', 'to', 'of', 'and', 'or', 'not', 'when', 'with', 'for', 'help', 'fix', 'do', 'i', 'can', 'how', 'why', 'does'].indexOf(w) < 0; });
  }

  var GENERIC = /\b(any|all|controllers?|cartridge|discs?)\b/;

  function score(row, terms, pairs, qsys) {
    var s = 0;
    if (!row._sys) row._sys = norm(row.systems + ' ' + expand(row.systems).join(' '));
    var sym = norm(row.symptom), sys = row._sys, body = norm(row.check + ' ' + row.fix);
    terms.forEach(function (t) {
      if (sym.indexOf(t) >= 0) s += HARD.indexOf(t) >= 0 ? 20 : 6;
      if (sys.indexOf(t) >= 0) s += 4;
      if (body.indexOf(t) >= 0) s += 1;
    });
    // phrases beat loose words: "game boy" and "no sound" together should win
    pairs.forEach(function (b) {
      if (sym.indexOf(b) >= 0) s += 5;
      if (sys.indexOf(b) >= 0) s += 4;
    });
    // naming a system is the strongest signal there is: rows for the named
    // system go up, rows for a different named system go down hard, and rows
    // that apply to any system stay in the running.
    if (qsys.length) {
      var hit = qsys.some(function (t) { return sys.indexOf(t) >= 0; });
      if (hit) s += 6;
      else if (GENERIC.test(sys)) s += 3;
      else s -= 12;
    }
    if (row.kind === 'notbroken') s += 0.5;
    return s;
  }

  function money(fmt, amount) {
    var n = parseFloat(amount);
    var str = isNaN(n) ? String(amount) : n.toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}|AMOUNT/, str).replace(/<[^>]+>/g, '');
  }

  roots.forEach(function (root) {
    var input = root.querySelector('[data-fx-input]');
    var form = root.querySelector('[data-fx-form]');
    var list = root.querySelector('[data-fx-results]');
    var status = root.querySelector('[data-fx-status]');
    var empty = root.querySelector('[data-fx-empty]');
    var tplR = root.querySelector('[data-fx-tpl-result]');
    var tplP = root.querySelector('[data-fx-tpl-product]');
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 6;
    var perResult = parseInt(root.getAttribute('data-products'), 10) || 3;
    var predict = root.getAttribute('data-predict');
    var rootUrl = root.getAttribute('data-root') || '/';
    var fmt = root.getAttribute('data-money') || '$AMOUNT';
    var data = null;
    var timer = null;

    function load() {
      if (data) return Promise.resolve(data);
      // Fetch exactly the URL in the setting. Use the versioned (?v=) Files URL:
      // a re-upload gets a new v, which is a new cache key everywhere at once.
      return fetch(root.getAttribute('data-src')).then(function (r) { return r.json(); }).then(function (j) { data = j; return j; });
    }

    function products(row, host, browse) {
      var q = row.q, col = row.col, must = row.must || [];
      if (!q) {
        if (col) { browse.href = rootUrl.replace(/\/$/, '') + '/collections/' + col; browse.hidden = false; host.parentNode.hidden = false; }
        return;
      }
      var url = predict + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=' + perResult + '&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) {
        var items = (j && j.resources && j.resources.results && j.resources.results.products) || [];
        items = items.filter(function (p) {
          var t = String(p.title || '').toLowerCase();
          return must.every(function (g) { return g.split('/').some(function (a) { return t.indexOf(a.toLowerCase()) >= 0; }); });
        });
        if (!items.length) {
          if (col) { browse.href = rootUrl.replace(/\/$/, '') + '/collections/' + col; browse.hidden = false; host.parentNode.hidden = false; }
          return;
        }
        items.forEach(function (p) {
          var n = tplP.content.cloneNode(true);
          var a = n.querySelector('a');
          a.href = p.url;
          var img = n.querySelector('[data-pimg]');
          if (p.featured_image && p.featured_image.url) { img.src = p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/, '_160x160$1$2'); img.alt = p.title; } else { img.remove(); }
          n.querySelector('[data-ptitle]').textContent = p.title;
          n.querySelector('[data-pprice]').textContent = money(fmt, p.price);
          var st = n.querySelector('[data-pstock]');
          st.textContent = p.available ? 'In stock' : 'Sold out';
          if (!p.available) st.classList.add('bench-fx__pstock--out');
          host.appendChild(n);
        });
        if (col) { browse.href = rootUrl.replace(/\/$/, '') + '/collections/' + col; browse.hidden = false; }
        host.parentNode.hidden = false;
      }).catch(function () {});
    }

    function render(rows, q) {
      list.innerHTML = '';
      empty.hidden = rows.length > 0;
      status.textContent = rows.length ? (rows.length + (rows.length === 1 ? ' match' : ' matches') + ' for "' + q + '"') : '';
      rows.forEach(function (row) {
        var n = tplR.content.cloneNode(true);
        var li = n.querySelector('li');
        if (row.kind === 'notbroken') li.classList.add('is-notbroken');
        n.querySelector('[data-sys]').textContent = row.systems;
        n.querySelector('[data-sheet]').textContent = 'Sheet ' + row.sheet;
        n.querySelector('[data-symptom]').textContent = row.symptom;
        n.querySelector('[data-check]').textContent = row.check;
        n.querySelector('[data-fix]').textContent = row.fix;
        if (row.kind === 'notbroken') {
          n.querySelector('[data-fixlabel]').textContent = 'What to do';
          li.querySelector('.bench-fx__k--free').textContent = 'What it actually is';
        }
        var host = n.querySelector('[data-products]');
        var browse = n.querySelector('[data-browse]');
        list.appendChild(n);
        products(row, host, browse);
      });
    }

    function run(q, push) {
      q = String(q || '').trim();
      if (!q) { list.innerHTML = ''; empty.hidden = true; status.textContent = ''; return; }
      var terms = expand(q), pairs = bigrams(q);
      var qsys = terms.filter(function (t) { return SYSTEMS.indexOf(t) >= 0; });
      load().then(function (j) {
        var scored = j.rows.map(function (r) { return { r: r, s: score(r, terms, pairs, qsys) }; })
          .filter(function (x) { return x.s >= 6; })
          .sort(function (a, b) { return b.s - a.s; });
        // a clear winner should not drag four weak matches along behind it
        var top = scored.length ? scored[0].s : 0;
        scored = scored.filter(function (x) { return x.s >= Math.max(6, top * 0.5); })
          .slice(0, limit)
          .map(function (x) { return x.r; });
        render(scored, q);
        if (push && window.history && history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('q', q); history.replaceState(null, '', u.toString());
        }
      });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); run(input.value, true); });
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { run(input.value, false); }, 220);
    });
    root.querySelectorAll('[data-fx-chip]').forEach(function (b) {
      b.addEventListener('click', function () {
        input.value = b.getAttribute('data-fx-chip');
        run(input.value, true);
        input.focus();
      });
    });

    try {
      var initial = new URL(window.location.href).searchParams.get('q');
      if (initial) { input.value = initial; run(initial, false); }
    } catch (e) {}
    load();
  });
})();
